import { useState } from "react";
import { base44 } from "@/api/base44Client";
import { Button } from "@/components/ui/button";
import { AlertCircle, Trash2, LogOut } from "lucide-react";

export default function Profile() {
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  const handleLogout = () => {
    base44.auth.logout("/login");
  };

  const handleDeleteAccount = async () => {
    setDeleting(true);
    setError("");
    try {
      await base44.auth.me(); // confirm still authenticated
      // Log out and redirect to account deletion email
      const subject = encodeURIComponent("Account Deletion Request");
      const body = encodeURIComponent("Please delete my account and all associated data.");
      window.location.href = `mailto:support@waterslideshoustontx.com?subject=${subject}&body=${body}`;
      setTimeout(() => base44.auth.logout("/"), 1000);
    } catch (e) {
      setError("Something went wrong. Please email support@waterslideshoustontx.com to request account deletion.");
    } finally {
      setDeleting(false);
      setShowConfirm(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl shadow-lg p-8 space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Account</h1>

        <Button variant="outline" className="w-full flex items-center gap-2" onClick={handleLogout}>
          <LogOut className="w-4 h-4" />
          Log Out
        </Button>

        <div className="border-t border-border pt-6 space-y-3">
          <p className="text-sm text-muted-foreground">
            To delete your account, we'll open an email to our support team. Your account and all data will be permanently removed within 48 hours of your request.
          </p>

          {!showConfirm ? (
            <Button
              variant="destructive"
              className="w-full flex items-center gap-2"
              onClick={() => setShowConfirm(true)}
            >
              <Trash2 className="w-4 h-4" />
              Delete Account
            </Button>
          ) : (
            <div className="space-y-3">
              <div className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg">
                <AlertCircle className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-red-700">Are you sure? This cannot be undone.</p>
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <div className="flex gap-3">
                <Button variant="outline" className="flex-1" onClick={() => setShowConfirm(false)}>
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  className="flex-1"
                  onClick={handleDeleteAccount}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Yes, Delete"}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}